import dayjs from "dayjs";
const getHrReminders = async (fetch, locals) => {
  let hrReminders = {
    query: [],
    employeeReminders: [],
    calendly: []
  };
  let response;
  try {
    response = await fetch(`$api/hr/reminders?done=false&from=${dayjs().subtract(40, "day").format("YYYY-MM-DD")}`, {
      method: "GET",
      headers: locals.fetchAuthHeaders
    });
    if (response.ok) {
      hrReminders = await response.json();
    }
  } catch (e) {
    console.log(e);
    return hrReminders;
  }
  return hrReminders;
};
const getHrTodos = async (fetch, locals) => {
  let response;
  let hrTodos = {
    contractSignatures: {
      waitingForHR: [],
      waitingForEmployee: []
    }
  };
  try {
    response = await fetch(`$api/hr/todos`, {
      method: "GET",
      headers: locals.fetchAuthHeaders
    });
    if (response.ok) {
      hrTodos = await response.json();
    }
  } catch (e) {
    console.log(e);
    return hrTodos;
  }
  return hrTodos;
};
const getEmployeeCount = async (fetch, locals) => {
  let response;
  let employeeCount = {
    active: 0,
    inactive: 0,
    candidate: 0,
    interviewee: 0,
    onboarding: 0,
    sabbatical: 0
  };
  try {
    response = await fetch(`$api/employees/count`, {
      method: "GET",
      headers: locals.fetchAuthHeaders
    });
    if (response.ok) {
      employeeCount = await response.json();
    }
  } catch (e) {
    console.log(e);
    return employeeCount;
  }
  return employeeCount;
};
const load = async ({ locals, fetch, params }) => {
  return {
    delayed: {
      hrReminders: getHrReminders(fetch, locals),
      employeeCount: getEmployeeCount(fetch, locals),
      hrTodos: getHrTodos(fetch, locals)
    },
    page_title: "Employees"
  };
};
export {
  load
};
//# sourceMappingURL=_page.server.ts.js.map
